import { restAxios } from './httpClient';

/*
 * Remote support lives on rest-api under `/v1/licensing` (SYN-3378). The maintenance plans here are
 * the same rows as the legacy "Maintenance types" list on central-api; rest-api only adds the
 * `remoteSupportAllowed` flag, so the ids line up with the rows the table already shows.
 */
const MAINTENANCE_PLANS_PATH = '/v1/licensing/maintenance-plans';
const REMOTE_SUPPORT_OVERRIDES_PATH = '/v1/licensing/remote-support-overrides';

export const getMaintenancePlans = ({ page, pageSize } = {}, { signal } = {}) => {
	return restAxios.get(MAINTENANCE_PLANS_PATH, {
		params: { page, pageSize },
		signal
	});
};

export const patchMaintenancePlanRemoteSupport = (maintenancePlanId, remoteSupportAllowed) => {
	return restAxios.patch(`${MAINTENANCE_PLANS_PATH}/${maintenancePlanId}`, { remoteSupportAllowed });
};

export const getProductRemoteSupport = (productId, { signal } = {}) => {
	return restAxios.get(`/v1/licensing/products/${productId}/remote-support`, { signal });
};

/*
 * The user is not sent: Central records the signed-in one as the grantor.
 */
export const createRemoteSupportOverride = (productId, reason) => {
	return restAxios.post(REMOTE_SUPPORT_OVERRIDES_PATH, { productId, reason });
};
